'use strict';

const React = require('react'),
    {t} = require('services/i18nextWrapper'),
    CustomDialog = require('components/Commons/Dialog/CustomDialogHolder'),
    SessionStore = require('stores/SessionStore'),
    HistoryStore = require('stores/HistoryStore'),
    AdminScaffoldingGeneric = require('components/Commons/AdminScaffolding/AdminScaffoldingGeneric'),
    AdminScaffoldingTable = require('components/Commons/AdminScaffolding/AdminScaffoldingTable/AdminScaffoldingTable'),
    AdminScaffoldingContextHolder = require('components/Commons/AdminScaffolding/AdminScaffoldingContextHolder'),
    Loading = require('components/Commons/Loading/Loading'),
    FormGroupDropdown = require('components/Commons/BasicForm/FormGroupDropdown/FormGroupDropdown'),
    FormGroupButton = require('components/Commons/BasicForm/FormGroupButton/FormGroupButton'),
    Authentication = require('services/Security').Authentication,
    { find, filter, map } = require('lodash/collection'),
    DateUtils = require('utils/DateUtils'),
    get = require('lodash/object').get,
    NavigationUtils = require('utils/NavigationUtils'),
    { Navigation } = require('react-router'),
    HistoryModal = require('./HistoryModal/HistoryModal'),
    AppConstants = require('constants/AppConstants'),
    ga = require('react-ga');

const HistoryAdmin = React.createClass({displayName: "HistoryAdmin",
    mixins: [Authentication, AdminScaffoldingContextHolder, Navigation],

    getInitialState() {
        let selectedModule = NavigationUtils.getQueryParam('selected-module');
        if (selectedModule) {
            selectedModule = find(
                AppConstants.APP_MODULES,
                module => module.name === selectedModule
            );
        }
        return {
            selectedModule,
            selectedItem: null,
            isEditMode: false
        };
    },

    _modalEl: null,

    componentDidMount() {
        this.fetchHistorys();
        ga.pageview('/history-admin');
    },

    fetchHistorys() {
        const self = this;
        HistoryStore.fetchHistories(function(histories) {
            self.setState({
                histories: self._customHydration(histories)
            });
        });
    },

    _customHydration(histories) {
        return map(histories, history => {
            return history;
        });
    },

    _onDeleteBeerStyle(tank, onSuccess, onFailure) {
        CustomDialog.showWarningConfirmation(
            t('warning'),
            t('history_admin_confirm_delete_history'),
            () => {
                HistoryStore.deleteStyleBeer(tank, onSuccess, onFailure);
            }
        );
    },

    _onChangeBeerStyle(tank, onSuccess, onFailure) {
        HistoryStore.changeStyleBeer(tank, onSuccess, onFailure);
    },

    _onRowSelection(item, itemIndex, lastRowScrollPosition) {
        this.setState(
            prevState => {
                return {
                    selectedItem: item,
                    isEditMode: !prevState.isEditMode
                };
            },
            () => {
                // stay the position of the scroll after row select when
                // the offset is outside of initial viewport page.
                this.getDOMNode().querySelector(
                    '.mui-body-table'
                ).scrollTop = lastRowScrollPosition;
            }
        );
    },

    _onCancel() {
        this.setState({
            selectedItem: null,
            isEditMode: false
        });
    },

    _formatRowChanges(changes) {
        return map(changes, change => {
            change.dateDisplay = DateUtils.toYYYYMMDDhhmm(change.date);
            return change;
        });
    },

    _onChangeModule() {
        this.setState({
            selectedModule: get(arguments, '2.itemModel')
        });
    },

    _openMoreDetail() {
        this._modalEl.show();
    },

    render() {
        if (!this.state.histories) {
            return React.createElement(Loading, null);
        } else {
            const messages = {
                changeSuccessMessage: t('history_admin_change_success_message'),
                changeFailureMessage: t('history_admin_change_failure_message'),
                deleteSuccessMessage: t('history_admin_delete_success_message'),
                addSuccessMessage: t('history_admin_add_success_message'),
                addFailureMessage: t('history_admin_add_failure_message')
            };
            let { selectedItem, selectedModule, histories } = this.state;
            let contextHolder = this.getContextHolderInstance();
            const filteredHistories = find(
                histories,
                history => history.module === get(selectedModule, 'name')
            );

            const additionalButtons = [
                {
                    type: 'CHANGE',
                    el: (
                        React.createElement(FormGroupButton, {
                            label: t('history_admin_label_show_more_detail'), 
                            icon: "subdirectory_arrow_right", 
                            type: "icon", 
                            onClick: this._openMoreDetail.bind(
                                this,
                                selectedItem
                            )}
                        )
                    )
                }
            ];

            const formFieldsEl = [
                React.createElement(FormGroupDropdown, {
                    items: filter(
                        AppConstants.APP_MODULES,
                        module => !module.isDisabled
                    ), 
                    operationsHolder: contextHolder, 
                    displayAttribute: "displayName", 
                    readerAttribute: "displayName", 
                    writerAttribute: "displayName", 
                    name: t('label_modules'), 
                    value: selectedModule, 
                    isEditMode: selectedItem !== undefined, 
                    onChange: this._onChangeModule}
                )
            ];

            return (
                React.createElement("div", {className: "bp-history-admin"}, 
                    React.createElement(HistoryModal, {
                        ref: ref => (this._modalEl = ref), 
                        historySelected: selectedItem, 
                        selectedModule: selectedModule}
                    ), 
                    React.createElement(AdminScaffoldingGeneric, {
                        messages: messages, 
                        title: t('history_admin_title_history_changes'), 
                        contextHolder: contextHolder, 
                        value: selectedItem, 
                        fetchItems: this.fetchHistorys, 
                        headerFields: formFieldsEl, 
                        onCancel: this._onCancel, 
                        additionalButtons: additionalButtons
                    }, 
                        React.createElement(AdminScaffoldingTable, {
                            onRowSelection: this._onRowSelection, 
                            value: selectedItem, 
                            sortByColumn: ['date'], 
                            columnNames: [
                                t('history_admin_column_name_date_display'),
                                t('history_admin_column_name_type'),
                                t('history_admin_column_name_user')
                            ], 
                            filteredColumns: [
                                'dateDisplay',
                                'type',
                                'userName'
                            ], 
                            displayAttributes: [
                                'dateDisplay',
                                'type',
                                'userName'
                            ]
                        }, 
                            this._formatRowChanges(
                                get(filteredHistories, 'changes')
                            )
                        )
                    )
                )
            );
        }
    }
});

module.exports = HistoryAdmin;



/** WEBPACK FOOTER **
 ** ./src/views/HistoryAdmin/HistoryAdmin.jsx
 **/